<template>
  <div l-type="long-rectangle" l-search="true" l-title="false" l-bar="true">
    <template v-if="!is_loading && campaigns?.data?.length > 0">
      <TableData>
        <template slot="tbl__header">
          <TableHeader :count="campaigns.total" />
        </template>
        <template slot="tbl__body">
          <TableBody v-for="(campaign, index) in campaigns?.data" :key="campaign.id" :campaign="campaign" :index="index" />
        </template>
      </TableData>
    </template>

    <!-- No Campaigns  -->
    <div class="text-center mt-7" v-else>
      <div class="text-28px font-bold">You do not have any campaigns</div>
      <template v-if="($canAccess(['agency', 'agency-employee', 'employee', 'brand-employee']) || $isTopBrandAdmin()) && !$is_PM && !$is_GD">
        <p>Click here to create your first campaign</p>
        <ElButton @click="createCampaign"> <i class="el-icon-plus el-icon-left"></i> {{ $t('campaign.index.new_campaign') }} </ElButton>
      </template>
    </div>

    <!-- Pagination -->
    <div v-if="campaigns.last_page > 1" class="flex my-2 dynamic-height">
      <ElPagination
        class="mx-auto"
        :current-page.sync="currentPage"
        :page-size="campaigns.per_page"
        :disabled="is_loading"
        :total="campaigns.total"
        hide-on-single-page
        layout="prev, pager, next, jumper, ->"
        @current-change="changePage"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
const TableData = () => import(/* webpackChunkName: "_table-data" */ '@/components/tabledata')
const TableHeader = () =>
  import(/* webpackChunkName: "_table-data" */ '@/components/social-products/social-boost/parts/table/TableHeader.vue')
const TableBody = () => import(/* webpackChunkName: "_table-data" */ '@/components/social-products/social-boost/parts/table/TableBody.vue')
import CampaignType from '@/components/social-products/social-boost/modal/CampaignType'

export default {
  name: 'SocialBoostList',
  components: {
    TableData,
    TableHeader,
    TableBody,
  },
  data() {
    return {
      currentPage: 1,
    }
  },
  async created() {
    this.$route.query.page ? (this.currentPage = parseInt(this.$route.query.page)) : (this.currentPage = 1)
  },
  computed: {
    ...mapGetters('socialBoostCampaign', ['campaigns']),
    ...mapGetters('app', ['is_loading']),
    campaignsStatus() {
      return this.$route.meta.campaign_state
    },
  },
  watch: {
    campaignsStatus: {
      async handler(value) {
        const params = { ...this.$route.query }
        if (value !== null && typeof value !== 'undefined') Object.assign(params, { status: value })
        await this.$store.dispatch('socialBoostCampaign/getCampaigns', { ...params })
        this.currentPage = 1
      },
      immediate: true,
    },
    '$route.query.sort': {
      handler() {
        this.$store.dispatch('socialBoostCampaign/getCampaigns', { ...this.$route.query })
      },
      immediate: true,
    },
  },
  methods: {
    async changePage(page) {
      this.currentPage = page
      const query = { ...this.$route.query, page: page }
      this.$router.push({ query: query })
      await this.$store.dispatch('socialBoostCampaign/getCampaigns', { ...query })
    },
    createCampaign() {
      this.$Modal.init(
        {
          propsData: {
            component: CampaignType,
            meta: { title: 'Create Campaign' },
            size: '480px',
          },
          callback(payload) {
            if (payload.event === 'modal:close') {
              console.log('>>>>>')
            }
          },
        },
        this
      )
    },
  },
}
</script>
